import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-report-day-range-picker',
  templateUrl: './report-day-range-picker.component.html',
  styleUrls: ['./report-day-range-picker.component.scss'],
  standalone: false,
})
export class ReportDayRangePickerComponent implements OnInit {
  dateForm!: UntypedFormGroup;

  @Output() rangechanged = new EventEmitter<{ from: Date; to: Date } | undefined>();

  @Input() isReloading = true;
  @Input() isInit = false;
  @Input() @HostBinding('class.compact') compact = false;

  errorDateRange = false;
  readonly maxDate = new Date();

  private calendarOpen = false;
  private settingRange = false;
  private lastEmitted?: { from: Date; to: Date } | null;

  ngOnInit(): void {
    this.createDateForm();
  }

  createDateForm(): void {
    const to = new Date();
    const from = new Date(to.getFullYear(), to.getMonth() - 12, to.getDate() + 1);

    this.dateForm = new UntypedFormGroup({
      from: new UntypedFormControl(from),
      to: new UntypedFormControl(to),
    });

    this.dateForm.valueChanges.subscribe(() => {
      if (!this.calendarOpen && !this.settingRange) {
        this.emitRange();
      }
    });
    this.emitRange();
  }

  public setRange(from: Date, to: Date): void {
    this.settingRange = true;
    this.dateForm.setValue({ from, to });
    this.settingRange = false;
    this.lastEmitted = undefined;
    this.emitRange();
  }

  onCalendarOpened(): void {
    this.calendarOpen = true;
  }

  onCalendarClosed(): void {
    this.calendarOpen = false;
    this.emitRange();
  }

  private emitRange(): void {
    const { from, to } = this.dateForm.value;

    if (!from || !to) {
      return;
    }

    if (from > to) {
      this.errorDateRange = true;
      if (this.lastEmitted !== null) {
        this.lastEmitted = null;
        this.rangechanged.emit(undefined);
      }
      return;
    }

    this.errorDateRange = false;
    if (this.lastEmitted && this.lastEmitted.from === from && this.lastEmitted.to === to) {
      return;
    }
    this.lastEmitted = { from, to };
    this.rangechanged.emit({ from, to });
  }
}
